<template>
  <section>
    <div class="l-service">
      <div class="l-service-header">
        <h2 class="heading-default heading-default-center">IRニュース</h2>
        <h3 class="heading-small heading-small-center heading-small-mt-sp">
          IR NEWS
        </h3>

        <div class="l-service-content-inner">
          <!-- E-IR Parts -->
          <div id="eirArea"></div>
          <div id="doEirWrapper"></div>
          <!-- /E-IR Parts -->
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  metaInfo() {
    return {
      title: "IRニュース",
      titleTemplate: "IRニュース | IR情報 | 株式会社 旅工房",
    };
  },
  mounted: function () {
    this.$nextTick(() => {
      let doEirWrapper = document.getElementById("doEirWrapper");
      let doEirScript = document.createElement("script");
      doEirScript.innerHTML = 'setParts("news")';
      doEirWrapper.appendChild(doEirScript);
    });
  },
};
</script>
